import { useLayoutEffect } from "react";
import { useMatch, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Box, IconButton, Stack } from "@mui/material";
import { styled } from "@mui/styles";
import Close from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";
import ArrowBackIosNewOutlinedIcon from "@mui/icons-material/ArrowBackIosNewOutlined";
import useMediaQuery from "@mui/material/useMediaQuery";
import { toggleSidebar } from "../../actions";

import UserMenuOptions from "../UserMenuOptions/UserMenuOptions";
import Logo from "../../images/BPOTechLogo.svg";
import "./navbarauth.scss";

// import SearchBar from "./SearchBar";
// import MessageButton from "./MessageButton";
// import NotificationButton from "./NotificationButton";
import { useDarkMode } from "../../hooks/useDarkMode";

const StyledNavbar = styled(Box)(({ theme }) => ({
  borderWidth: "0 0 1px 0",
  borderStyle: "solid",
  borderColor: theme.palette.border.divider,
}));

function NavbarAuth() {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const role = useSelector((state) => state.auth.role);
  const isOpen = useSelector((state) => !state.sidebar.isOpen);
  const { isDark } = useDarkMode();
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width: 1200px)");

  const matchRoute = useMatch("/edit-bpo-report/:id");

  useLayoutEffect(() => {
    const navbar = document.getElementsByClassName("navbar")[0];
    document.documentElement.style.setProperty(
      "--navheight",
      navbar.clientHeight + "px",
    );
  }, []);

  const MenuButton = isOpen ? Close : MenuIcon;

  return (
    <StyledNavbar className="navbar-mod navbar">
      <IconButton
        sx={{
          position: "absolute",
          zIndex: 9999,
          left: isOpen ? "10px" : "17px",
          root: {
            padding: "5px !important",
          },
        }}
        onClick={() => {
          dispatch(toggleSidebar());
        }}
      >
        <MenuButton
          className="menu-icon"
          fontSize="medium"
          htmlColor={isMobile ? "black" : "secondary.main"}
        />
      </IconButton>

      <Box
        className="logo-mod"
        sx={{
          width: !isOpen ? "80px !important" : "inherit",
          transition: "all 0.3s",
        }}
        onClick={() => {
          if (role === "realty_agent") {
            window.location.assign(process.env.REACT_APP_BPOHOMESREALTY_URL);
          } else {
            navigate("/");
          }
        }}
      >
        {isOpen && (
          <>
            <img src={Logo} alt="logo" />

            {/* Find a better way to show this for pages that requires custom side-menus */}
            {matchRoute && (
              <IconButton
                sx={{
                  position: "absolute",
                  right: "10px",
                  borderRadius: "6px",
                  backgroundColor: "#F9FAFB",
                }}
                href="/bpo-report"
              >
                <ArrowBackIosNewOutlinedIcon
                  sx={{ fontSize: 14, color: "alternate.6" }}
                />
              </IconButton>
            )}
          </>
        )}
      </Box>

      {/* <SearchBar /> */}
      <Box />

      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        {/* <MessageButton /> */}
        {/* <NotificationButton isDark={isDark} /> */}

        <Stack
          sx={{
            borderWidth: "0 0 0 1px",
            borderStyle: "solid",
            borderColor: "#EEE",
            paddingLeft: "0.5rem",
          }}
        >
          <UserMenuOptions name={`${auth.first_name} ${auth.last_name}`} />
        </Stack>
      </Box>
    </StyledNavbar>
  );
}

export default NavbarAuth;
